import { compose, branch, renderNothing } from 'recompose';
import { isAdminSite } from '~/utils';

import LearnerRedirection from './components/Learner/Redirection';

export default compose(branch(() => !!isAdminSite(), renderNothing))(LearnerRedirection);
